import {
  BlankSlate,
  BlankSlateIcon,
  BlankSlateTitle,
  Box,
  FileDropZone,
} from "@prismicio/editor-ui"
import type { ReactNode } from "react"

interface ImageFieldDropZoneProps {
  uploadImage: (file: File) => void
  children: ReactNode
  isUploading: boolean
  disabled?: boolean
}

export function ImageFieldDropZone(props: ImageFieldDropZoneProps) {
  const { uploadImage, children, isUploading, disabled } = props

  if (disabled) return <>{children}</>

  function onFilesSelected(files: File[]) {
    if (isUploading) return

    const firstFile = files[0]
    if (!firstFile) return

    uploadImage(firstFile)
  }

  return (
    <FileDropZone
      assetType="image"
      maxFiles={1}
      onFilesSelected={onFilesSelected}
      overlay={<ImageFieldDropZoneOverlay isUploading={isUploading} />}
    >
      {children}
    </FileDropZone>
  )
}

interface ImageFieldDropZoneOverlayProps {
  isUploading: boolean
}

function ImageFieldDropZoneOverlay(props: ImageFieldDropZoneOverlayProps) {
  const { isUploading } = props

  const title = isUploading
    ? "You can't upload while the upload is ongoing"
    : "Drop image to instantly upload"

  return (
    <Box
      justifyContent="center"
      flexDirection="column"
      height="100%"
      padding={8}
    >
      <BlankSlate>
        <BlankSlateIcon
          name={isUploading ? "block" : "cloudUpload"}
          lineColor={isUploading ? "tomato11" : "purple10"}
          backgroundColor={isUploading ? "tomato2" : "purple3"}
          borderColor={isUploading ? "tomato6" : "purple6"}
          borderStyle="dashed"
          size="small"
        />
        <BlankSlateTitle size="regular">{title}</BlankSlateTitle>
      </BlankSlate>
    </Box>
  )
}
